var map = {
	"./Accordion.svg": 538,
	"./Breadcrumb.svg": 539,
	"./Button.svg": 540,
	"./Checkbox.svg": 541,
	"./Code snippet.svg": 542,
	"./Content switcher.svg": 543,
	"./Data table.svg": 544,
	"./Date picker.svg": 545,
	"./Dropdown.svg": 546,
	"./File uploader.svg": 547,
	"./Form.svg": 548,
	"./Inline loading.svg": 549,
	"./Link.svg": 550,
	"./List.svg": 551,
	"./Loading.svg": 552,
	"./Modal.svg": 553,
	"./Multiselect.svg": 554,
	"./NoImage.svg": 341,
	"./Notification.svg": 555,
	"./Number input.svg": 556,
	"./Overflow menu.svg": 557,
	"./Pagination.svg": 558,
	"./Progress indicator.svg": 559,
	"./Radio button.svg": 560,
	"./Search.svg": 561,
	"./Select.svg": 562,
	"./Slider.svg": 563,
	"./Structured list.svg": 564,
	"./Tabs.svg": 565,
	"./Tag.svg": 566,
	"./Text input.svg": 567,
	"./Tile.svg": 568,
	"./Toggle.svg": 569,
	"./Tooltip.svg": 570,
	"./UI shell.svg": 571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;